module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-supply-chain-responsible-efficient.eb1cc63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-supply-chain-responsible-efficient.jpg
// module id = MXKS
// module chunks = 0